<template>
    <div class="create-new-plan-modal">
        <div class="create-new-plan">
            <div class="create-new-plan-form">
                <div>
                    <div style="font-weight: bold">Settings</div>
                    <a-checkbox v-model="form.isFreePlan">{{ $t("billing.freePack") }}</a-checkbox>
                    <a-checkbox v-if="!form.isFreePlan" v-model="form.isOnDemand"
                        >{{ $t("billing.instantFee") }}
                    </a-checkbox>
                    <a-checkbox v-if="!form.isFreePlan" v-model="form.isTeamPlan"
                        >{{ $t("billing.teamPackage") }}
                    </a-checkbox>
                    <a-checkbox v-if="!form.isFreePlan" v-model="form.isAppsumo"
                        >{{ $t("billing.appsumoPack") }}
                    </a-checkbox>
                    <a-checkbox v-if="!form.isFreePlan" v-model="form.isEnterPrise"> Enter Prise Plan</a-checkbox>
                </div>
                <div>
                    <div style="font-weight: bold">{{ $t("billing.planSequence") }}</div>
                    <a-input class="plan-input" v-model="form.order" :min="0" type="number"></a-input>
                </div>
                <div v-if="form.isAppsumo">
                    <div style="font-weight: bold">{{ $t("billing.requiredCodes") }}</div>
                    <a-input class="plan-input" v-model="form.requiredCodes" :min="0" type="number"></a-input>
                </div>
                <div>
                    <div style="font-weight: bold">{{ $t("message.title") }}</div>
                    <a-input class="plan-input" v-model="form.title" type="text"></a-input>
                </div>
                <div>
                    <div style="font-weight: bold">{{ $t("billing.subHeading") }}</div>
                    <a-input class="plan-input" v-model="form.altTitle" type="text"></a-input>
                </div>
                <div>
                    <div style="font-weight: bold">{{ $t("billing.packageType") }}</div>
                    <a-select v-model="form.type" style="width: 100%">
                        <a-select-option v-for="type in types" :key="type.key" :value="type.key">
                            {{ type.title }}
                        </a-select-option>
                    </a-select>
                </div>
                <div
                    style="margin-top: 15px"
                    v-if="!form.isEnterPrise && (form.type === 'custom' || form.type === 'feature')"
                >
                    <div style="font-weight: bold">
                        {{ form.type === "custom" ? "Custom Paket Key" : $t("billing.featureKey") }}
                    </div>
                    <a-input
                        class="plan-input"
                        v-model="form.dynamicType"
                        type="text"
                        placeholder="whatsapp-broadcast"
                    />
                </div>
                <div style="margin-top: 15px" v-if="form.isEnterPrise">
                    <div style="font-weight: bold">Enter Price URL</div>
                    <a-input class="plan-input" v-model="form.enterPriseUrl" type="text" />
                </div>
                <div style="margin-top: 15px" v-if="!form.isEnterPrise">
                    <div style="font-weight: bold">{{ $t("billing.featureKey") }}</div>
                    <a-input class="plan-input" v-model="form.partnerKey" type="text" placeholder="appsumo" />
                </div>
                <div
                    style="margin-top: 15px"
                    v-if="!form.isFreePlan && form.type !== 'automation' && !form.isEnterPrise"
                >
                    <div style="font-weight: bold">{{ $t("billing.monthlyPrice") }}</div>
                    <a-input class="plan-input" :min="0" type="number" v-model="form.price" />
                </div>
                <div v-if="['automation', 'mail'].includes(form.type)" style="width: 100%">
                    <div style="display: flex; align-items: center; justify-content: space-between">
                        <div style="font-weight: bold">Fiyatlandırma</div>
                        <SupsisButton @click="addPricing" ghost>Yeni Satır Ekle</SupsisButton>
                    </div>
                    <div
                        v-for="(selectFeature, index) of form.selectFeatures || []"
                        style="display: flex; align-items: center; gap: 10px; margin-top: 10px; width: 100%"
                    >
                        <a-button @click="removePricing(index)" type="danger" icon="delete" />
                        <div style="align-self: flex-start">
                            {{ form.type === "automation" ? "Otomasyon Kullanımı" : "Email Kullanımı" }}
                            <a-input
                                class="plan-input"
                                :value="selectFeature.count"
                                :min="0"
                                type="number"
                                @input="updatePricing(index, $event.target.value, selectFeature.price)"
                            />
                        </div>
                        <div style="align-self: flex-start" v-if="form.type === 'mail'">
                            Email Kişi Sayısı
                            <a-input
                                class="plan-input"
                                :value="selectFeature.details.uniqEmailContactCount"
                                :min="0"
                                type="number"
                                @input="updateSelectFeatureDetails(index, 'uniqEmailContactCount', $event.target.value)"
                            />
                        </div>
                        <div style="align-self: flex-start">
                            Price
                            <a-input
                                class="plan-input"
                                :value="selectFeature.price"
                                :min="0"
                                type="number"
                                @input="updatePricing(index, selectFeature.count, $event.target.value)"
                            />
                        </div>
                    </div>

                    <hr />
                </div>
                <div
                    style="margin-top: 15px"
                    v-if="!form.isFreePlan && form.type !== 'automation' && !form.isEnterPrise"
                >
                    <div style="font-weight: bold">{{ $t("billing.monthlyNonDiscounted") }}</div>
                    <a-input class="plan-input" :min="0" type="number" v-model="form.discountPrice" />
                </div>
                <div style="margin-top: 5px" v-if="!form.isFreePlan && !form.isEnterPrise">
                    <div style="font-weight: bold">{{ $t("billing.twoYearDiscount") }}</div>
                    <a-input class="plan-input" :min="0" type="number" v-model="form.twoYearDiscount" />
                </div>
                <div style="margin-top: 5px" v-if="!form.isFreePlan && !form.isEnterPrise">
                    <div style="font-weight: bold">{{ $t("billing.yearDisccount") }}</div>
                    <a-input class="plan-input" :min="0" type="number" v-model="form.yearlyDiscount" />
                </div>
                <div style="margin-top: 5px" v-if="!form.isFreePlan && !form.isEnterPrise">
                    <div style="font-weight: bold">{{ $t("billing.sixMonthDiscount") }}</div>
                    <a-input class="plan-input" :min="0" type="number" v-model="form.sixMonthlyDiscount" />
                </div>
                <div style="margin-top: 5px" v-if="!form.isFreePlan && !form.isEnterPrise">
                    <div style="font-weight: bold">{{ $t("billing.threeMonthDiscount") }}</div>
                    <a-input class="plan-input" :min="0" type="number" v-model="form.threeMonthlyDiscount" />
                </div>
                <div style="margin-top: 5px">
                    <div style="font-weight: bold">{{ $t("billing.features") }}</div>
                    <div style="width: 100%">
                        <a-select v-model="featuresForm" style="width: 100%" @select="onSelectFeaturesForm">
                            <a-select-option v-for="feature in featureTypes" :key="feature.key" :value="feature.key">
                                {{ feature.title }}
                            </a-select-option>
                        </a-select>
                        <div style="margin-top: 10px">
                            <AgentFeature
                                v-if="features.includes('agent')"
                                v-model="form"
                                @close="deleteFeature('agent')"
                            />
                            <ArchiveFeature
                                v-if="features.includes('archive')"
                                v-model="form"
                                @close="deleteFeature('archive')"
                            />
                            <ChatFeature
                                v-if="features.includes('chat')"
                                v-model="form"
                                @close="deleteFeature('chat')"
                            />
                            <ChatBotFeature
                                v-if="features.includes('chatbot')"
                                v-model="form"
                                @close="deleteFeature('chatbot')"
                            />
                            <MailFeature
                                v-if="features.includes('mail')"
                                v-model="form"
                                @close="deleteFeature('mail')"
                            />
                            <ReportFeature
                                v-if="features.includes('report')"
                                v-model="form"
                                @close="deleteFeature('report')"
                            />
                            <SMSFeature v-if="features.includes('sms')" v-model="form" @close="deleteFeature('sms')" />
                            <SupportFeature
                                v-if="features.includes('support')"
                                v-model="form"
                                @close="deleteFeature('support')"
                            />
                            <SystemFeature
                                v-if="features.includes('system')"
                                v-model="form"
                                @close="deleteFeature('system')"
                            />
                            <TeamChatFeature
                                v-if="features.includes('team_chat')"
                                v-model="form"
                                @close="deleteFeature('team_chat')"
                            />
                            <TriggerFeature
                                v-if="features.includes('trigger')"
                                v-model="form"
                                @close="deleteFeature('trigger')"
                            />
                            <WhatsappFeature
                                v-if="features.includes('whatsapp')"
                                v-model="form"
                                @close="deleteFeature('whatsapp')"
                            />
                            <InstagramFeature
                                v-if="features.includes('instagram')"
                                v-model="form"
                                @close="deleteFeature('instagram')"
                            />
                            <MessengerFeature
                                v-if="features.includes('messenger')"
                                v-model="form"
                                @close="deleteFeature('messenger')"
                            />
                            <TrendyolFeature
                                v-if="features.includes('trendyol')"
                                v-model="form"
                                @close="deleteFeature('trendyol')"
                            />
                            <ServicesFeature
                                v-if="features.includes('services')"
                                v-model="form"
                                @close="deleteFeature('services')"
                            />
                            <AutomationFeature
                                v-if="features.includes('automation')"
                                v-model="form"
                                @close="deleteFeature('automation')"
                            />
                            <FormFeature
                                v-if="features.includes('form')"
                                v-model="form"
                                @close="deleteFeature('form')"
                            />
                            <MetaLeadFeature
                                v-if="features.includes('meta-lead')"
                                v-model="form"
                                @close="deleteFeature('meta-lead')"
                            />
                            <CustomerTablesFeature
                                v-if="features.includes('customer-tables')"
                                v-model="form"
                                @close="deleteFeature('customer-tables')"
                            />
                            <TaskFeature
                                v-if="features.includes('tasks')"
                                v-model="form"
                                @close="deleteFeature('tasks')"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="create-new-plan-preview">
                <Card :plan="planStructure" :isReadonly="true" />
            </div>
        </div>
        <div class="create-new-plan-modal-footer">
            <SupsisButton primary @click="updateAction" v-if="form._id">
                {{ $t("message.update") }}
            </SupsisButton>
            <SupsisButton primary v-else @click="createAction">
                {{ $t("message.save") }}
            </SupsisButton>
            <SupsisButton @click="cancelAction" ghost>{{ $t("billing.cancelIt") }}</SupsisButton>
        </div>
    </div>
</template>
<script>
import Modal from "../common/Modal2.vue";
import _ from "lodash";
import { mapState } from "vuex";
import AgentFeature from "./feature-items/Agent";
import ArchiveFeature from "./feature-items/Archive";
import ChatFeature from "./feature-items/Chat";
import ChatBotFeature from "./feature-items/Chatbot";
import MailFeature from "./feature-items/Mail";
import ReportFeature from "./feature-items/Report";
import SMSFeature from "./feature-items/SMS";
import SupportFeature from "./feature-items/Support";
import SystemFeature from "./feature-items/System";
import TeamChatFeature from "./feature-items/TeamChat";
import TriggerFeature from "./feature-items/Triggers";
import WhatsappFeature from "./feature-items/Whatsapp";
import ServicesFeature from "./feature-items/Services.vue";
import InstagramFeature from "./feature-items/Instagram.vue";
import MessengerFeature from "./feature-items/Messenger.vue";
import TrendyolFeature from "./feature-items/Trendyol.vue";
import AutomationFeature from "./feature-items/AutomationFeature.vue";
import FormFeature from "./feature-items/FormFeature.vue";
import Card from "./Card.vue";
import SupsisButton from "../../views/Pages/Settings/components/SupsisButton.vue";
import MetaLeadFeature from "./feature-items/MetaLead.vue";
import CustomerTablesFeature from "./feature-items/CustomerTables.vue";
import TaskFeature from "./feature-items/TaskFeature.vue";

export default {
    name: "CreateNewPlanModal",
    components: {
        TaskFeature,
        CustomerTablesFeature,
        MetaLeadFeature,
        SupsisButton,
        Card,
        FormFeature,
        AutomationFeature,
        TrendyolFeature,
        MessengerFeature,
        InstagramFeature,
        ServicesFeature,
        Modal,
        AgentFeature,
        ArchiveFeature,
        ChatFeature,
        ChatBotFeature,
        MailFeature,
        ReportFeature,
        SMSFeature,
        SupportFeature,
        SystemFeature,
        TeamChatFeature,
        TriggerFeature,
        WhatsappFeature,
    },
    props: {
        value: {
            type: Object,
        },
    },
    data: () => ({
        form: {
            twoYearDiscount: 40,
            yearlyDiscount: 30,
            sixMonthlyDiscount: 20,
            threeMonthlyDiscount: 10,
        },
        featuresPricingForm: null,
        featuresForm: null,
        features: [],
        types: [
            { key: "supsis", title: "Supsis" },
            { key: "whatsapp", title: "Whatsapp" },
            { key: "whatsapp-business", title: "Whatsapp Business" },
            { key: "chatbot", title: "Chatbot" },
            { key: "instagram", title: "Instagram" },
            { key: "messenger", title: "Messenger" },
            { key: "telegram", title: "Telegram" },
            { key: "trendyol", title: "Trendyol" },
            { key: "meta-lead", title: "MetaLead" },
            { key: "form", title: "Form" },
            { key: "automation", title: "Automation" },
            { key: "customer-tables", title: "Customer Tables" },
            { key: "mail", title: "Email" },
            { key: "feature", title: "Özellik" },
            { key: "tasks", title: "Task" },
            { key: "webhook", title: "Webhook" },
            { key: "artificial-intelligence", title: "Artificial Intelligence" },
            { key: "custom", title: "Custom" },
        ],
        featureTypes: [
            { key: "agent", title: "Agent" },
            { key: "archive", title: "Archive" },
            { key: "chat", title: "Chat" },
            { key: "chatbot", title: "Chatbot" },
            { key: "mail", title: "Mail" },
            { key: "report", title: "Report" },
            { key: "sms", title: "SMS" },
            { key: "support", title: "Support" },
            { key: "system", title: "System" },
            { key: "team_chat", title: "Team Chat" },
            { key: "automation", title: "Otomasyon" },
            { key: "customer-tables", title: "Customer Tables" },
            { key: "form", title: "Form" },
            { key: "tasks", title: "Task" },
            { key: "trigger", title: "Triggers" },
            { key: "whatsapp", title: "Whatsapp" },
            { key: "instagram", title: "Instagram" },
            { key: "messenger", title: "Messenger" },
            { key: "trendyol", title: "Trendyol" },
            { key: "meta-lead", title: "Meta Lead" },
            { key: "services", title: "Services" },
        ],
    }),
    computed: {
        ...mapState({
            systemLanguages: (state) => state.setting.settings.systemLanguages,
            plans: (state) =>
                state.site.plans.reduce((a, b) => {
                    a[b.dynamicType || b.type] = b;
                    return a;
                }),
        }),
        planStructure() {
            const structure = {};
            structure.title = this.form.title;
            structure.altTitle = this.form.altTitle;
            structure.type = this.form.type;
            structure.dynamicType = this.form.dynamicType;
            structure.partnerKey = this.form.partnerKey;
            structure.price = +this.form.price;
            structure.discountPrice = +this.form.discountPrice;
            structure.twoYearDiscount = +this.form.twoYearDiscount;
            structure.yearlyDiscount = +this.form.yearlyDiscount;
            structure.sixMonthlyDiscount = +this.form.sixMonthlyDiscount;
            structure.threeMonthlyDiscount = +this.form.threeMonthlyDiscount;
            structure.features = this.form.features || [];
            structure.isFreePlan = this.form.isFreePlan;
            structure.isOnDemand = this.form.isOnDemand;
            structure.isAppsumo = this.form.isAppsumo;
            structure.isTeamPlan = this.form.isTeamPlan;
            structure.requiredCodes = this.form.requiredCodes;
            structure.selectFeatures = this.form.selectFeatures || [];
            structure.isEnterPrise = this.form.isEnterPrise;
            structure.enterPriseUrl = this.form.enterPriseUrl;
            return structure;
        },
    },
    mounted() {
        this.form = _.cloneDeep(
            this.value || {
                type: "custom",
                title: null,
                altTitle: null,
                isPopular: false,
                price: 0,
                discountPrice: 0,
                twoYearDiscount: 40,
                yearlyDiscount: 30,
                sixMonthlyDiscount: 20,
                threeMonthlyDiscount: 10,
                dynamicType: null,
                partnerKey: null,
                features: [],
                isFreePlan: false,
                isOnDemand: false,
                isAppsumo: false,
                isTeamPlan: false,
                isEnterPrise: false,
                requiredCodes: 0,
                selectFeatures: [],
                enterPriseUrl: null,
            }
        );
        this.features = this.form.features.map((f) => f.type);
        this.form.selectFeatures = this.form.selectFeatures.sort((a, b) => a.price - b.price);
    },
    methods: {
        addPricing() {
            this.form.selectFeatures = [
                ...(this.form.selectFeatures || []),
                {
                    count: 0,
                    price: 0,
                    details: {},
                },
            ];
        },
        removePricing(index) {
            this.form.selectFeatures = this.form.selectFeatures.filter((_, i) => i !== index);
        },
        updatePricing(index, count, price) {
            this.form.selectFeatures = this.form.selectFeatures.map((p, i) => {
                if (i === index) {
                    return {
                        count: +count,
                        price: +price,
                        details: p.details,
                    };
                }
                return p;
            });
        },
        updateSelectFeatureDetails(index, key, value) {
            this.form.selectFeatures = this.form.selectFeatures.map((p, i) => {
                if (i === index) {
                    return {
                        ...p,
                        details: {
                            ...p.details,
                            [key]: +value,
                        },
                    };
                }
                return p;
            });
        },
        cancelAction() {
            this.$emit("cancel");
        },
        createAction() {
            this.form.selectFeatures = this.form.selectFeatures.sort((a, b) => a.price - b.price);
            this.$emit("input", this.form);
            this.$emit("create", this.form);
        },
        updateAction() {
            this.form.selectFeatures = this.form.selectFeatures.sort((a, b) => a.price - b.price);
            this.$emit("input", this.form);
            this.$emit("update", this.form);
        },
        onSelectFeaturesForm(val) {
            if (!this.features.includes(val)) this.features = [...this.features, val];
            this.featuresForm = null;
        },
        deleteFeature(key) {
            this.features = this.features.filter((f) => f !== key);
            this.form.features = this.form.features.filter((x) => x.type !== key);
        },
    },
    watch: {
        form: {
            handler(newVal, oldVal) {
                if (_.isEqual(newVal, oldVal)) {
                    if (newVal.isAppsumo) {
                        this.form.type = "custom";
                        this.form.partnerKey = "appsumo";
                        this.form.dynamicType = "appsumo";
                    }
                    if (newVal.isFreePlan) {
                        this.form.price = 0;
                    }
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
.create-new-plan-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
    background: white;
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    gap: 30px;

    .create-new-plan {
        display: flex;
        justify-content: space-between;
        gap: 20px;
        height: 100%;
        overflow: auto;

        .create-new-plan-form {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 15px;

            .plan-input {
                width: 100%;
                border: none;
                padding: 4px 8px;
                border-radius: 4px;
                background: #f6f6f6;
            }
        }

        .create-new-plan-preview {
            position: sticky;
            top: 0;
        }
    }

    &-footer {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        align-items: center;
    }
}
</style>
